// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionFieldPopupAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field selection component
 */

import { curry, map, isEmpty, includes } from 'lodash/fp';
import { withHandlers, compose } from 'recompose';

export default compose(
  withHandlers({
    closed: curry(closed),
    onChangeSeletedField: curry(onChangeSeletedField)
  })
);

async function closed(props: any, closeFunc: any, type: any) {
  if (type === 'cancel') {
    props.onReject();
  } else {
    // const props = this.props;
    const container = props.container;
    const selectedField = map(function(item) {
      const querySource = props.store.displayFieldQuerySource[item.querySource];
      const field = querySource.fields[item.field];

      return {
        field: field,
        querySource: querySource
      };
    }, this.selectedData);

    const result = props.validateAddNewFieldToReportPart(map('field', selectedField), false);
    let position = container.elements.length;
    let validField = false;

    if (!isEmpty(selectedField)) {
      await props.confirmTurnOffMultiColor();
      await props.confirmRemoveRegressionLine();
      Promise.map(selectedField, (item) => {
        if (!includes(item.field, result.errorField)) {
          position++;
          validField = true;
          return props.addField(item.field, item.querySource, position);
        }
        return Promise.resolve();
      })
        .then(() => {
          if (isEmpty(result.message)) {
            return null;
          }
          return !isEmpty(result.message) && props.warning(result.message);
        })
        .then(() => {
          if (validField) {
            props.onAccept();
            props.reportPart.shouldUpdatePreview && props.store.needUpdatePreview();
          }
        });

    }
  }
}

function onChangeSeletedField(props: any, data: any) {
  this.selectedData = data;
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.SelectionFieldPopupAction.js